import { t } from "@/i18n-js/instance";
import { ActionModal } from "@circle-react-shared/ModalsV2/ActionModal";
import { usePublicLiveStore } from "../store";

interface InfoBoxProps {
  room: {
    description: string;
  };
}

export const InfoBox = ({ room }: InfoBoxProps) => {
  const {
    isInfoBoxOpen,
    actions: { toggleInfoBox },
  } = usePublicLiveStore();

  const { description } = room;

  return (
    <ActionModal
      isOpen={isInfoBoxOpen}
      title={t("live_streams.room_info.title")}
      onClose={toggleInfoBox}
      onAction={toggleInfoBox}
      actionVariant="circle"
      actionText={t("live_streams.room_info.action")}
    >
      <div className="min-h-[233px]">
        {description && <div className="text-dark pt-6">{description}</div>}
      </div>
    </ActionModal>
  );
};
